<script lang="ts" setup>

// Props
const props = withDefaults(defineProps<{
  showLanguageSelector?: boolean
}>(), {
  showLanguageSelector: true
})

// Idioma
const { locale, t } = useI18n()

const { loggedIn } = useUserSession()

const selectedIdioma = computed(() => locale.value)

</script>

<template>
  <header class="top-0 left-0 right-0 w-full h-16 z-50 backdrop-blur-lg transition shadow-xs sticky bg-white/80">
    <div class="relative px-4 mx-auto flex items-center justify-between h-full max-w-7xl">
      <!-- Izquierda: logo -->
      <div class="flex items-center gap-4 shrink-0 z-10">
        <div class="sm:hidden">
          <UserZoneSidebar v-if="loggedIn" />
        </div>
        <NuxtLink :aria-label="$t('labels.aria.home')" :to="`/${locale}`">
          <Logo />
        </NuxtLink>
      </div>

      <!-- Mobile: bloque a la derecha | Desktop: centrado con ancho amplio -->
      <div
        class="absolute inset-x-0 inset-y-0 flex items-center justify-end lg:justify-center pointer-events-none pl-20 pr-0 lg:px-16"
      >
        <div
          id="simple-header-center"
          class="pointer-events-auto flex items-center justify-end lg:justify-center min-w-0 w-full max-w-md lg:w-full lg:max-w-2xl"
        />
      </div>

      <!-- Derecha: idioma (o spacer para equilibrar) -->
      <div class="flex items-center shrink-0 z-10 min-h-6 min-w-6">
        <UPopover v-if="props.showLanguageSelector">
          <UButton size="xs" :class="['hover:no-underline']" :aria-label="$t('labels.aria.idiomaMoneda')" variant="link"
            color="neutral" :label="`${selectedIdioma.toUpperCase()}`" />
          <template #content>
            <div class="flex flex-col gap-2 p-5 pt-3">
              <div>
                <p class="text-neutral-500 text-sm mb-1">{{ t('strapi.global.header.tituloIdioma') }}</p>
                <LocaleSelector class="w-48" />
              </div>
            </div>
          </template>
        </UPopover>
      </div>
    </div>
  </header>
</template>